import React, { Suspense } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SkuRefreshSummary from '../components/SkuRefreshSummary';
import StockFileStatus from '../components/StockFileStatus';
import Grid from '@mui/material/Unstable_Grid2';
import VendorSKUStatus from '../components/VendorSKUStatus';
import StockFileStats from '../components/StockFileStats';
import Skeleton from '@mui/material/Skeleton';

export default function Dashboard() {
  return (
    <Box sx={{ width: '100%' }}>
        <Box sx={{ mb: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
                Dashboard
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Overview of catalog sync activities, vendor health, and inventory availability
            </Typography>
        </Box>

        <Grid container spacing={3}>
            <Grid xs={12}>
                <SkuRefreshSummary />
            </Grid>

            <Grid xs={12}>
                <StockFileStatus />
            </Grid>

            <Grid xs={12} lg={6}>
                <Suspense fallback={<Skeleton variant="rounded" height={300} />}>
                    <VendorSKUStatus />
                </Suspense>
            </Grid>

            <Grid xs={12} lg={6}>
                <StockFileStats />
            </Grid>
        </Grid>
    </Box>
  );
}